import React from "react";
const Markdown = require("react-markdown");

const HTMLMarkdown = ({ source, escapeHtml }) => {
  return <Markdown source={source} escapeHtml={escapeHtml} />;
};

export { HTMLMarkdown };
